<template>
  <router-view></router-view>
</template>

<script>
/* eslint-disable vue/component-definition-name-casing */
/* eslint-disable vue/one-component-per-file */
/* eslint-disable vue/no-shared-component-data */

import { mapGetters } from 'vuex';

export default {
  name: 'app',
  metaInfo() {
    const impersonationDetails = this.GET_IMPERSONATION_SESSION;
    const isImpersonationActive = impersonationDetails?.active === true;
    const orgName =
      this.getAuthOrgName || isImpersonationActive
        ? this.GET_IMPERSONATION_SESSION.churchName
        : undefined;
    /** @type {string=} */

    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      /**
       * If you wish to use a child property conditionally and
       * use the parents' property as default value, make sure
       * the child returns undefined as content value
       *
       * https://vue-meta.nuxtjs.org/guide/special.html#use-child-property-conditionally
       */
      title: 'Gotedo Church Management Software',
      // all titles will be injected into this template
      titleTemplate: (chunk) => `${chunk}${orgName ? ` - ${orgName}` : ' - Gotedo Vineyard'}`,
    };
  },
  computed: {
    ...mapGetters('auth', ['getAuthOrgName']),
    currentRoute() {
      return this.$route;
    },
  },
  methods: {
    pushToLoginPageHandler() {
      this.$router.push({ name: 'Login' }).catch(() => {
        // Suppress redundant navigation error
      });
    },
  },
  mounted() {
    this.$emitter.on('push_to_login_page', this.pushToLoginPageHandler);
  },
  beforeDestroy() {
    this.$emitter.off('push_to_login_page', this.pushToLoginPageHandler);
  },
};
</script>

<style lang="scss">
@import 'assets/scss/style';

@font-face {
  font-family: 'GotedoAdminFrontendFont';
  src: url('./assets/fonts/Inter-VariableFont_slnt,wght.ttf');
}

body {
  font-family: GotedoAdminFrontendFont !important;
}

/* Import Line Awesome Icons Set */
$line-awesome-font-path: 'line-awesome/dist/line-awesome/fonts/';
@import '~line-awesome/dist/line-awesome/css/line-awesome.css';
</style>
